import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ColumnState, FilterModel } from "ag-grid-community";

export interface ExceptionsGridState {
  filterModel: FilterModel;
  columnState: ColumnState[];
}

interface ExceptionsStore {
  exceptionId: number | undefined;
  gridStates: Record<number, ExceptionsGridState>;
  setExceptionId: (id: number | undefined) => void;
  getGridState: (exceptionId: number) => ExceptionsGridState | undefined;
  saveGridState: (exceptionId: number, state: ExceptionsGridState) => void;
}

export const useExceptionsStore = create<ExceptionsStore>()(
  persist(
    (set, get) => ({
      exceptionId: undefined,
      gridStates: {},
      setExceptionId: (id) => set({ exceptionId: id }),
      // eslint-disable-next-line security/detect-object-injection
      getGridState: (exceptionId) => get().gridStates[exceptionId],
      saveGridState: (exceptionId, state) =>
        set((prev) => ({
          gridStates: { ...prev.gridStates, [exceptionId]: state },
        })),
    }),
    {
      name: "exceptions-store",
    },
  ),
);
